// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".div-top[data-v-108bf092],\n.div-search[data-v-108bf092] {\n  line-height: 30px;\n}\n.div-search[data-v-108bf092] {\n  margin-top: 10px;\n}\n.div-center[data-v-108bf092] {\n  margin-top: 10px;\n  height: calc(100% - 30px);\n}\n.title[data-v-108bf092] {\n  font-size: 20px;\n  font-weight: bold;\n  line-height: 40px;\n}", ""]);
// Exports
module.exports = exports;
